import { Table } from "reactstrap";

// This component displays invoice details including invoice number, date, payment status, and total amount.
export const InvoiceDateSection = () => {
  return (
    <td>
      <Table borderless >
        <tbody>
          <tr className="invoice-container">
            <td>
              <span >Invoice No.</span>
              <h4 >#VL25000365</h4>
            </td>
            <td>
              <span >Date :</span>
              <h4 >09/03/2024</h4>
            </td>
            <td>
              <span >Payment Status :</span>
              <h4 >Paid</h4>
            </td>
            <td>
              <span >Total Amount :</span>
              <h4 >$26,410.00</h4>
            </td>
          </tr>
        </tbody>
      </Table>
    </td>
  );
};
